<ng-select
        #select
        [items]="entries"
        bindLabel="name"
        bindValue="id"
        [(ngModel)]="selectedEntries"
        [loading]="loading"
        (change)="onSelectionChange($event)"
        [multiple]="false"
        [clearable]="false">
  <ng-template ng-label-tmp let-item="item">
    <div>{{ item.name }} - <small>{{ item.code }}</small></div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div>{{ item.name }} - <small>{{ item.code }}</small></div>
  </ng-template>
</ng-select>

